import styled from "styled-components";
import {
  FontAlign,
  FontSize,
  FontWeight,
  getFontAlign,
  getFontSizeAndLineHeight,
  getFontWeight,
} from "../../utils/Fonts";

export const Container = styled.p<{
  $fontSize?: FontSize;
  $fontAlign?: FontAlign;
  $fontWeight?: FontWeight;
  $fontColor?: string;
  $lineCount?: number;
}>`
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;
  user-select: none;
  color: ${(props) => props.$fontColor ?? "#3A3A3A"};
  text-align: ${(props) => getFontAlign(props.$fontAlign)};
  margin: unset;
  display: flex;
  font-family: "Open Sans", sans-serif;
  font-weight: ${(props) => getFontWeight(props.$fontWeight)};
  height: fit-content;
  ${(props) =>
    !!props.$lineCount &&
    `width: 100%;   -webkit-line-clamp: ${props.$lineCount};  -webkit-box-orient: vertical; overflow: hidden;text-overflow: ellipsis; display: -webkit-box;`};

  ${(props) => {
    const { fontSize, lineHeight } = getFontSizeAndLineHeight(props.$fontSize);
    return `
      font-size: ${fontSize};
      line-height: ${lineHeight};
    `;
  }} {
  }
`;
